// Traduções pt-BR
const ptBR = {
  dashboard: {
    title: "Resumo financeiro",
    subtitle: "Veja seu status financeiro e principais indicadores",
    cards: {
      balance: "Saldo",
      balance_predicted: "Saldo previsto",
      revenue: "Receitas",
      expenses: "Despesas",
      savings: "Economia",
      savings_predicted: "Economia prevista",
      profit: "Lucro",
      profit_predicted: "Lucro previsto"
    },
    last_transactions: "Últimas transações",
    view_all: "Ver todas",
    add_transaction: "Adicionar transação",
    expense_distribution: "Distribuição de despesas por categoria",
    cash_flow: "Fluxo de caixa",
    no_data: "Sem dados para exibir",
    no_expense_found: "Nenhuma despesa encontrada",
    loading_data: "Carregando dados...",
    filters: {
      period: "Período",
      from: "De",
      to: "Até",
      day: "Dia",
      week: "Semana",
      month: "Mês",
      year: "Ano",
      trend_day: "vs dia anterior",
      trend_week: "vs semana anterior",
      trend_month: "vs mês anterior",
      trend_year: "vs ano anterior",
      trend_default: "vs período anterior"
    },
    goals: {
      title: "Metas Financeiras",
      no_goals: "Nenhuma meta cadastrada",
      success: "Sucesso",
      updated: "Meta atualizada com sucesso!",
      value_updated: "Valor da meta atualizado com sucesso!",
      deleted: "Meta removida com sucesso!",
    },
    transactions: {
      no_transactions: "Nenhuma transação encontrada"
    },
    categories: {
      other: "Outros"
    }
  },
  transactions: {
    title: "Transações",
    add_new: "Adicionar nova",
    table: {
      date: "Data",
      description: "Descrição",
      category: "Categoria",
      account: "Conta",
      amount: "Valor"
    },
    form: {
      title_add: "Adicionar transação",
      title_edit: "Editar transação",
      description: "Descrição",
      amount: "Valor",
      date: "Data",
      category: "Categoria",
      account: "Conta",
      type: "Tipo",
      buttons: {
        cancel: "Cancelar",
        save: "Salvar"
      },
      feedback: {
        success: "Transação salva com sucesso!",
        error: "Ocorreu um erro ao salvar a transação."
      }
    },
    filters: {
      date_range: "Intervalo de datas",
      category: "Categoria",
      account: "Conta",
      type: "Tipo",
      reset: "Limpar filtros"
    },
    types: {
      revenue: "Receita",
      expense: "Despesa"
    }
  },
  cards: {
    title: "Cartões",
    add_new: "Adicionar novo",
    form: {
      title_add: "Adicionar cartão",
      title_edit: "Editar cartão",
      name: "Nome",
      bank: "Banco",
      limit: "Limite",
      buttons: {
        cancel: "Cancelar",
        save: "Salvar"
      },
      feedback: {
        success: "Cartão salvo com sucesso!",
        error: "Ocorreu um erro ao salvar o cartão."
      }
    },
    table: {
      name: "Nome",
      bank: "Banco",
      limit: "Limite",
      available: "Disponível"
    }
  },
  budgets: {
    title: "Orçamentos",
    add_new: "Adicionar novo",
    form: {
      title_add: "Adicionar orçamento",
      title_edit: "Editar orçamento",
      category: "Categoria",
      limit: "Limite",
      buttons: {
        cancel: "Cancelar",
        save: "Salvar"
      },
      feedback: {
        success: "Orçamento salvo com sucesso!",
        error: "Ocorreu um erro ao salvar o orçamento."
      }
    },
    table: {
      category: "Categoria",
      limit: "Limite",
      spent: "Gasto",
      remaining: "Restante"
    }
  },
  debts: {
    title: "Dívidas",
    add_new: "Adicionar nova",
    form: {
      title_add: "Adicionar dívida",
      title_edit: "Editar dívida",
      description: "Descrição",
      total: "Total",
      monthly_payment: "Pagamento mensal",
      due_date: "Data de vencimento",
      buttons: {
        cancel: "Cancelar",
        save: "Salvar"
      },
      feedback: {
        success: "Dívida salva com sucesso!",
        error: "Ocorreu um erro ao salvar a dívida."
      }
    },
    table: {
      description: "Descrição",
      total: "Total",
      monthly_payment: "Pagamento mensal",
      due_date: "Data de vencimento"
    }
  },
  goals: {
    title: "Metas",
    add_new: "Adicionar nova",
    form: {
      title_add: "Adicionar meta",
      title_edit: "Editar meta",
      description: "Descrição",
      target_amount: "Valor alvo",
      current_amount: "Valor atual",
      deadline: "Prazo",
      buttons: {
        cancel: "Cancelar",
        save: "Salvar"
      },
      feedback: {
        success: "Meta salva com sucesso!",
        error: "Ocorreu um erro ao salvar a meta."
      }
    },
    table: {
      description: "Descrição",
      target_amount: "Valor alvo",
      current_amount: "Valor atual",
      deadline: "Prazo"
    }
  },
  profile: {
    title: "Perfil",
    form: {
      name: "Nome",
      email: "Email",
      type: "Tipo de perfil",
      buttons: {
        cancel: "Cancelar",
        save: "Salvar"
      },
      feedback: {
        success: "Perfil salvo com sucesso!",
        error: "Ocorreu um erro ao salvar o perfil."
      }
    },
    types: {
      personal: "Pessoal",
      business: "Empresarial"
    }
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Gerencie seu perfil, preferências e dados do aplicativo',
    profile: {
      title: 'Perfil',
      name: 'Nome',
      email: 'E-mail'
    },
    security: {
      title: 'Segurança',
      changePassword: 'Alterar senha'
    },
    appearance: {
      title: 'Aparência',
      systemTheme: 'Tema do sistema'
    },
    data: {
      title: 'Gerenciar Dados',
      clearProfileData: 'Limpar dados do perfil',
      profileLabel: 'Perfil: {profileName}',
      warning: 'Esta ação removerá permanentemente todas as transações, categorias, cartões, dívidas e metas do perfil "{profileName}".',
      clearDataConfirm: 'Tem certeza que deseja limpar todos os dados do perfil "{profileName}"? Esta ação não pode ser desfeita.'
    },
    currentProfile: 'Perfil atual',
    feedback: {
      success: "Configurações salvas com sucesso!",
      error: "Ocorreu um erro ao salvar as configurações."
    }
  },
  theme: {
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema'
  },
  common: {
    buttons: {
      add: "Adicionar",
      edit: "Editar",
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      update: "Atualizar",
      confirm: "Confirmar",
      close: "Fechar",
      view: "Ver",
      search: "Buscar"
    },
    actions: {
      create: "Criar",
      update: "Atualizar"
    },
    status: {
      loading: "Carregando...",
      success: "Sucesso!",
      error: "Erro"
    }
  },
  forms: {
    account: {
      title_new: "Nova Conta",
      title_edit: "Editar Conta",
      label_name: "Nome da Conta",
      placeholder_name: "Ex: Conta Corrente Principal",
      label_bank: "Banco",
      placeholder_bank: "Ex: Nubank, Bradesco, Itaú",
      label_balance: "Saldo Atual",
      label_color: "Cor de Identificação",
      description: "Preencha os dados para criar uma nova conta bancária",
      button_cancel: "Cancelar",
      button_create: "Criar Conta",
      button_update: "Atualizar Conta"
    },
    category: {
      title_new: "Nova Categoria",
      title_edit: "Editar Categoria",
      title_edit_color: "Editar Cor da Categoria",
      label_name: "Nome da Categoria",
      placeholder_name: "Ex: Supermercado, Freelance",
      label_type: "Tipo",
      option_receita: "Receita",
      option_despesa: "Despesa",
      label_color: "Cor da Categoria",
      description_new: "Preencha os dados para criar uma nova categoria de transações",
      description_edit: "Altere os dados da categoria",
      description_edit_color: "Altere a cor desta categoria padrão",
      button_cancel: "Cancelar",
      button_create: "Criar Categoria",
      button_update: "Atualizar Categoria"
    },
    card: {
      title_new: "Novo Cartão",
      title_edit: "Editar Cartão",
      label_name: "Nome do Cartão",
      label_bank: "Banco/Instituição",
      label_limit: "Limite do Cartão",
      label_due: "Vencimento (Dia)",
      label_color: "Cor do Cartão",
      label_account: "Conta Vinculada",
      placeholder_name: "Ex: Cartão Principal",
      placeholder_bank: "Ex: Nubank, Bradesco, Itaú",
      button_cancel: "Cancelar",
      button_create: "Criar Cartão",
      button_update: "Atualizar Cartão",
      description: "Configure os dados do seu cartão de crédito. Todo cartão deve estar vinculado a uma conta bancária para controlar gastos e limites.",
      validation: {
        account_required: "É obrigatório vincular o cartão a uma conta bancária"
      }
    },
    budget: {
      title_new: "Novo Orçamento",
      title_edit: "Editar Orçamento",
      label_category: "Categoria de Despesa",
      label_amount: "Valor do Orçamento",
      label_period: "Período",
      option_diario: "Diário",
      option_semanal: "Semanal",
      option_mensal: "Mensal",
      option_anual: "Anual",
      button_cancel: "Cancelar",
      button_create: "Criar Orçamento",
      button_update: "Atualizar Orçamento",
      description: "Defina um limite de gastos para uma categoria específica",
      warning_all_used: "Todas as categorias já possuem orçamentos ativos."
    }
  }
};
export default ptBR;
